export const InputType = [
  "input",
  "text",
  "textarea",
  "number",
  "password",
  "email",
  "search",
  "tel",
  "url",
];

export const DateRangeType = [
  "year",
  "years",
  "month",
  "months",
  "date",
  "dates",
  "datetime",
  "week",
  "datetimerange",
  "daterange",
  "monthrange",
  "yearrange",
];

export const isInputType = (type) => {
  return InputType.includes(type);
};

export const isDateRangeType = (type) => {
  return DateRangeType.includes(type);
};
